import Markdown from 'react-markdown';
import { DOC_MARKDOWN_ALLOWED_ELEMENTS } from '../lib/documentMarkdown';

/**
 * Renders a binder document `body` (normal-form Markdown — see
 * `documentMarkdown.ts` / client-contract §3.7.1.x) as real elements. Only the
 * four supported constructs are allowed through: **bold**, *italic*, and
 * bulleted / numbered lists. Anything else (headings, code, links, raw HTML) is
 * dropped by the allowlist — react-markdown builds React nodes with no
 * dangerouslySetInnerHTML and no raw-HTML pass-through, so there is no
 * injection surface (the same safe precedent as SupportChat). Styling is
 * applied to the generated descendants via Tailwind arbitrary-variant
 * selectors so we don't substitute raw colors for the design tokens.
 */
export default function DocumentBodyView({ markdown }: { markdown: string }): JSX.Element {
  const trimmed = markdown.trim();
  if (!trimmed) {
    return <p className="text-[13px] text-hbs-text-mute">No body text.</p>;
  }
  return (
    <div className="text-[15px] text-hbs-text [&_p]:my-2 [&_p:first-child]:mt-0 [&_p:last-child]:mb-0 [&_strong]:font-semibold [&_em]:italic [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-0.5">
      <Markdown allowedElements={DOC_MARKDOWN_ALLOWED_ELEMENTS} unwrapDisallowed>
        {trimmed}
      </Markdown>
    </div>
  );
}
